import gql from "graphql-tag";

import { questionFields } from "../../graphql/fragments";

export const QUESTIONS_QUERY = gql`
  query getOrgsQuestions($organisationId: ID, $category: FormCategory) {
    questions(organisationId: $organisationId, category: $category) {
      ...questionFields
    }
  }
  ${questionFields}
`;

export const TEAMS_QUERY = gql`
  query getOrgTeams {
    teams: assignableTeams {
      id
      name
      members {
        id
        name
      }
    }
  }
`;

export const OUTCOMES_QUERY = gql`
  query getOrgOutcomes {
    outcomes {
      id
      name
      guidance
      suppressForAnalytics
      hideOutcome
    }
  }
`;

export const SITES_QUERY = gql`
  query getOrgSites {
    sites {
      id
      name
      urls {
        id
        status
        host
        isCanonical
      }
      language
      hideReportPage
      forms {
        id
        name
        title
        category
        slug
      }
    }
  }
`;

export const CROSS_ORG_QUERY = gql`
  query getOrgData($organisationId: ID!) {
    organisation(id: $organisationId) {
      id
      name
      teams {
        id
        name
        members {
          id
          name
        }
      }
      outcomes {
        id
        name
        guidance
        suppressForAnalytics
        hideOutcome
      }
      sites {
        id
        name
        urls {
          id
          status
          host
          isCanonical
        }
        language
        hideReportPage
        forms {
          id
          name
          title
          category
          slug
        }
      }
      featureGates
      ssoProvider
      isTemplateOrg
      isTestSite
      template {
        id
      }
    }
  }
`;
